export const commandColors = {
    /** Normal interactions (e.g. click, type, scroll, hover) */
    interact: "text-blue-500",
    /** Assertions */
    assert: "text-green-500",
    /** Time */
    time: "text-gray-500",
    /** Navigation */
    navigate: "text-emerald-500",
    /** Unknown commands */
    unknown: "text-gray-500",
};
